(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDialogController', TestScheduleDialogController);

    TestScheduleDialogController.$inject = ['$scope', '$state', 'ObjectTestResult', 'ParseLinks', 'AlertService', 'TabObjects', '$timeout', 'name', 'tabFleets', 'fleet', 'objType', 'tests', 'TabObjectTypes', 'ObjectTestSetting', 'testSchedule'];

    function TestScheduleDialogController($scope, $state, ObjectTestResult, ParseLinks, AlertService, TabObjects, $timeout, name, tabFleets, fleet, objType, tests, TabObjectTypes, ObjectTestSetting, testSchedule) {
        var vm = this;

        vm.testSchedule = testSchedule;
        vm.tabFleets = tabFleets;
        vm.tabObjectTypes = [];
        vm.tests = [];
        vm.selection = {fleet: -1, objectType: -1};

        vm.loadAll = function () {
            if(vm.testSchedule == null) { //create schedule
                if(fleet && objType && tests && name) { // se sono tornato indietro dalla pagina dialog-next
                    vm.selectedTests = tests;
                    vm.fleet = fleet;
                    vm.objType = objType;
                    vm.scheduleName = name;
                    vm.selection = {fleet: fleet.id, objectType: objType.id};
                    loadTests();
                    TabObjectTypes.byFleet({id: fleet.id}, onSuccess, onError);
                }
            }
            else { //edit schedule
                vm.selectedTests = tests ? tests : testSchedule.tests; //Se faccio back in fase di edit, mi prendo i tests dello stateparams altrimenti prendo quelli della schedulazione
                vm.scheduleName = name ? name : testSchedule.name;
                vm.fleet = testSchedule.tests[0].tabFleets; //tutti i test associati alla schedule hanno stessa flotta e type, quindi prendo il primo test.
                vm.objType = testSchedule.tests[0].tabObjectTypes;
                loadTests();
            }
            function onSuccess(data) {
                vm.tabObjectTypes = data;
            }
        }

        function loadTests() {
                if (vm.fleet && vm.objType) {
                    ObjectTestSetting.notManualTests({
                        objectTypeId: vm.objType.id,
                        fleetId: vm.fleet.id,
                    }, onSuccess, onError);
                }
                //tirare su i test associati alla schedule passsando l'id schedule (il parametro tests li dovrà avere)
                //tirare su i test associabili (avrò flotta e objType grazie ai test associati)

            function onSuccess(data) {
                vm.tests = data;
                if(vm.selectedTests) { //se ho fatto una back dalla pagina dialog-next o se sto facendo una edit, mi porto i test che avevo selezionato prima e setto check a true;
                    checkSelectedTests(vm.selectedTests);
                }

                function checkSelectedTests(selectedTests) {
                    vm.tests.forEach(function (test) {
                        test.check = false;
                        selectedTests.forEach(function (selectedTest) {
                            if (test.id === selectedTest.id)
                                test.check = true;
                        });
                    });
                    vm.tests.sort((a,b) => b.check - a.check);
                }
            }
        }


        /* selezionata la flotta popolo la select degli object type */
        vm.selectedFleet = function (fleet) {
            if (vm.selection.fleet.id !== fleet.id) {
                vm.selection.fleet = fleet.id;
                vm.fleet = fleet;
                vm.objType = null;
                TabObjectTypes.byFleet({id: fleet.id}, onSuccess, onError);
            }

            function onSuccess(data) {
                vm.tabObjectTypes = [];
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
                if(data.length === 1) {
                    vm.selectedObjectType(vm.tabObjectTypes[0]);
                }
            }
        };

        vm.selectedObjectType = function (objType) {
            if (vm.selection.objectType !== objType.id) {
                vm.selection.objectType = objType.id;
                vm.objType = objType;
                loadTests();
            }

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.checkAll = function (b) {
            vm.tests.forEach(function (test) {
                test.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.tests.forEach(function (test) {
                allChecked = test.check && allChecked;
                notChecked = !test.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneTest = function () {
            var isChecked = false;
            vm.tests.forEach(function (test) {
                isChecked = isChecked || test.check
            });
            return isChecked;
        }

        vm.loadAll();

        vm.next = function () {
            var selectedTests = [];
            vm.tests.forEach(function (test) {
                if(test.check)
                    selectedTests.push(test);
            });
            if(vm.testSchedule == null) {
                $state.go('test-schedule.new-next', {
                    name: vm.scheduleName,
                    fleet: vm.fleet,
                    include: vm.isActive,
                    objType: vm.objType,
                    tests: selectedTests
                }, {location: "replace"});
            }
            else {
                $state.transitionTo('test-schedule.edit-next', {
                    id: vm.testSchedule.id,
                    name: vm.scheduleName,
                    testSchedule: vm.testSchedule,
                    fleet: vm.fleet,
                    include: vm.isActive,
                    objType: vm.objType,
                    tests: selectedTests
                }, {location: "replace"});
            }
        }
    }
})();
